import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import PasswordField from './PasswordField';
import styles from './MokaAuth.css';

class MokaAuth extends React.Component {
  state = {
    password: '',
    errorMessage: '',
  };

  handlePasswordChange = e => {
    this.setState({
      password: e.target.value,
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { onNext } = this.props;
    const { password } = this.state;

    const error = this.validateForm();

    if (!error) {
      onNext(password);
    } else {
      this.setState({
        errorMessage: error,
      });
    }
  };

  validateForm = () => {
    const { password } = this.state;

    if (!password) {
      return t`Enter a password`;
    }
    if (password.length < 6) {
      return t`Password must be 6 or more characters`;
    }

    return '';
  };

  render() {
    const { loginId, onReset, appName } = this.props;
    const { password, errorMessage } = this.state;

    const isSubmitDisabled = !password;

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          {appName ? (
            <div className={styles.titleOpenPlatform}>
              <Trans>
                Sign in to use <strong>{appName}</strong>
              </Trans>
            </div>
          ) : (
            <div className={styles.title}>
              <Trans>Sign In</Trans>
            </div>
          )}

          <div className={styles.loginIdPreview}>
            <span className={styles.loginIdPreviewText}>{loginId}</span>
            <a className={styles.loginIdPreviewChangeLink} onClick={onReset}>
              <Trans>Change</Trans>
            </a>
          </div>

          <div className={styles.instruction}>
            <Trans>Enter your password</Trans>
          </div>
        </div>

        <form onSubmit={this.handleSubmit}>
          <div
            className={classNames('form-group', { 'has-error': errorMessage })}
          >
            <I18n>
              {({ i18n }) => (
                <PasswordField
                  name="password"
                  className="form-control"
                  placeholder={i18n._(t`Password`)}
                  maxLength="40"
                  autoFocus
                  value={password}
                  onChange={this.handlePasswordChange}
                />
              )}
            </I18n>

            {errorMessage && (
              <span className="text-danger">
                <Trans id={errorMessage} />
              </span>
            )}
          </div>

          <div className="form-group">
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={isSubmitDisabled}
            >
              <Trans>Sign In</Trans>
            </button>
          </div>
        </form>

        <div className={styles.footer}>
          <Link to="/forgot">
            <Trans>Forgot password?</Trans>
          </Link>
        </div>
      </div>
    );
  }
}

MokaAuth.defaultProps = {
  loginId: '',
  appName: '',
  onReset: () => {},
  onNext: () => {},
};

export default MokaAuth;
